var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#FFF","stroke-linecap":"round","stroke-width":"2","d":"M6 1v10m5-5H1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }